import React from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import Model23Form from "../Model23Form";
import {useCreateModel23} from "../query";
import MDBox from "materialDashboard/components/MDBox";

const Model23Create = () => {
    const {t} = useTranslation(['models23']);
    const navigate = useNavigate();
    const createModel23 = useCreateModel23();

    const handleSubmit = async (data) => {
        await createModel23.mutateAsync(data);
        await navigate('/models23');
    }

    return <MDBox sx={{mx: 2}}>
        <Model23Form title={t('model23Create.title')}
                     onSubmit={handleSubmit}/>
    </MDBox>
}

export default Model23Create;